module.exports = __webpack_public_path__ + "img/caprock_merchant.f5805cb6.png";